import React from 'react';
import LegalDocumentPage from './LegalDocumentPage.js';
import { getTermsSections } from './legalContent.js';

function TermsAndConditionsPage({ isMobile }) {
  return <LegalDocumentPage isMobile={isMobile} content={getTermsSections()} />;
}

export default TermsAndConditionsPage;